/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loginheading1Inputs */

const en_loginheading1 = /** @type {(inputs: Loginheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const pt_loginheading1 = /** @type {(inputs: Loginheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Loginheading1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const loginheading1 = /** @type {((inputs?: Loginheading1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loginheading1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loginheading1(inputs)
	return pt_loginheading1(inputs)
});
export { loginheading1 as "loginHeading" }